export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export type TransformedDataPoint = {
  name: string;
  onTheBooks: number;
  previous: number;
};

/**
 * Transforms the data for the revenue chart
 * @param data - The data for the current year
 * @param prevData - The data for the previous year
 * @param forecastData - The data for the forecasted year
 *
 * @returns
 * [
 *  {
 *      name: "Jan",
 *      onTheBooks: 1000,
 *      previous: 1000,
 *      forecast: 1000,
 *  }
 *  ...
 *  {
 *      name: "Dec",
 *      onTheBooks: 1000,
 *      previous: 1000,
 *      forecast: 1000,
 *  }
 * ]
 */
export const transformData = ({
  data = [],
  previousField,
  onTheBooksField,
  currentField,
  startDate,
  endDate,
  budgetField,
}: {
  data: any[];
  previousField: string;
  onTheBooksField: string;
  currentField: string;
  startDate: string;
  endDate: string;
  budgetField: string;
}): TransformedDataPoint[] => {
  return data.map((month) => {
    return {
      name: months[Number(month?.month || 0) - 1],
      current: Number(month[currentField] || 1),
      actualCurrent: Number(month[currentField] || 0),
      onTheBooks: Number(month[onTheBooksField] || 0),
      previous: Number(data[previousField] || 0),
      budget: Number(month?.budget?.[budgetField] || 0),
    };
  });
};
